import preloadImg from '../../../_utils/img/preloadImg'
import generateUUID from '../../../_utils/math/generateUUID'

export default class Texture {
  constructor() {
    this._loadPromise = null;
    this._isLoaded = false;
    this._uuid = generateUUID();
    this.textureUnitIndex = Texture.textureCnt++;

    this._isBindedOnce = false;
    this._isDisposed = false;
    this._isCanvas = false;

    this.wrapS = 'CLAMP_TO_EDGE';
    this.wrapT = 'CLAMP_TO_EDGE';
    this.magFilter = 'LINEAR';
    this.minFilter = 'LINEAR';
    this.mipmap = false;

    this._type = 'UNSIGNED_BYTE';
    this._format = 'RGBA';
  }

  get uuid() {
    return this._uuid;
  }

  get isLoaded() {
    return this._isLoaded;
  }

  get img() {
    return this._img;
  }

  get isDesposed() {
    return this._isDisposed;
  }

  getGLTexture() {
    return this._glTexture;
  }

  setCanvas(canvas) {
    this._isLoaded = true;
    this._isCanvas = true;
    this._img = canvas;
    this.updateGLTexture();
  }

  async load(imgPath) {
    this._imgPath = imgPath;
    return this._loadPromise = preloadImg(this._imgPath)
    .then((img)=> {
      this._img = img;
      this._isLoaded = true;
    })
  }

  dispose() {
    if(this._isDisposed) return;

    this._isLoaded = false;
    this._imgPath = '';
    if(!this._isCanvas) this._img.src = '';
    this._img = null;
    this._deleteGLTexture();
    this._gl = null;

    this._isDisposed = true;
  }

  bind(uniformLocation) {
    // テクスチャが複数ある場合におかしくなる
    // if(!this._glTexture || uniformLocation == -1 || this._isBindedOnce) return;

    if(uniformLocation == -1 || !this._glTexture) return;

    this._gl.activeTexture(this._gl['TEXTURE' + this.textureUnitIndex.toString()]);
    this._gl.bindTexture(this._gl.TEXTURE_2D, this._glTexture);
    this._gl.uniform1i(uniformLocation, this.textureUnitIndex);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_S, this._gl[this.wrapS]);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_T, this._gl[this.wrapT]);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, this._gl[this.magFilter]);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, this._gl[this.minFilter]);
  }

  setGLContext(gl) {
    this._gl = gl;

    let ext;
    if(this._type == 'FLOAT') {
      if(!this._gl.getExtension('OES_texture_float')) {
        throw new Error('no support float texture');
      }
      this.type = this._gl[this._type];

    } else if(this._type == 'HALF_FLOAT_OES') {
      ext = this._gl.getExtension('OES_texture_half_float');
      if(ext) {
        this.type = ext.HALF_FLOAT_OES;
      } else {
        throw new Error('no support half float texture');
      }
    } else {
      this.type = this._gl[this._type];
    }

    this.format = this._gl[this._format];

    this._createGLTexture();
  }

  updateGLTexture() {
    if(!this._glTexture) return;
    this._gl.bindTexture(this._gl.TEXTURE_2D, this._glTexture);
    this._gl.texImage2D(this._gl.TEXTURE_2D, 0, this.format, this.format, this.type, this._img);
    if(this.mipmap) this._gl.generateMipmap(this._gl.TEXTURE_2D);
    this._gl.bindTexture(this._gl.TEXTURE_2D, null);
    return this._glTexture;
  }

  _createGLTexture() {
    if(!this._img) return;
    this._glTexture = this._gl.createTexture();
    this._gl.bindTexture(this._gl.TEXTURE_2D, this._glTexture);
    this._gl.texImage2D(this._gl.TEXTURE_2D, 0, this.format, this.format, this.type, this._img);
    if(this.mipmap) this._gl.generateMipmap(this._gl.TEXTURE_2D);
    this._gl.bindTexture(this._gl.TEXTURE_2D, null);
    return this._glTexture;
  }

  _deleteGLTexture() {
    if(!this._glTexture) return;
    this._gl.deleteTexture(this._glTexture);
    this._glTexture = null;
    this._isBindedOnce = false;
  }
}

Texture.textureCnt = 0;
